export default [
    {
      path: '/admin/agency/request-for-deliveries',
      name: 'request-for-delivery',
      meta: { requiresAuth: true },
      component: () => import('@/pages/agency/request-for-delivery/index.vue')
    }
  ]
